import Tel1Summary from "./summary";
function Tel1Tool({ summaryData = [] }) {
  return (
    <>
      <div className="d-flex mb-3">
        <div className="flex-1 d-flex flex-column">
          <div>Alat Bantu Training/Training Aids</div>
          <Tel1Summary summaryData={summaryData} />
        </div>
      </div>
    </>
  );
}

export default Tel1Tool;
